import $ from 'jquery';
import Cookies from 'js-cookie';
import ky from 'ky';
import select2 from 'select2';

select2($);

import type { Reservation } from './types/reservation';

const csrftoken = Cookies.get('csrftoken');

type Room = {
  id: number;
  name: string;
};

type AvailableRoomPayload = {
  date: string;
  startTime: string;
  endTime: string;
};

document.addEventListener('DOMContentLoaded', () => {
  const getCurrentRoom = () => {
    return parseInt(roomElement.value, 10);
  };

  const form = document.querySelector('#newReservationForm');
  const dateElement = document.querySelector('#id_date') as HTMLInputElement;
  const startTimeElement = document.querySelector('#id_start_time') as HTMLInputElement;
  const endTimeElement = document.querySelector('#id_end_time') as HTMLInputElement;
  const roomElement = document.querySelector('#id_room') as HTMLSelectElement;
  const commentElement = document.querySelector('#id_comment') as HTMLInputElement;
  const extraUsersElement = document.querySelector('#id_extra_users') as HTMLSelectElement;
  const buttonElement = document.querySelector('#submitNewReservationForm') as HTMLButtonElement;
  const newReservationSuccessElement = document.querySelector('#newReservationSuccess') as HTMLElement;
  const newReservationAlertElement = document.querySelector('#newReservationAlert') as HTMLElement;
  const addModalCloseButtonElement = document.querySelector('#addModalCloseButton') as HTMLElement;

  $('#id_extra_users').select2({
    width: '100%',
    placeholder: 'Sélectionnez les utilisateurs',
    allowClear: true,
    multiple: true,
    dropdownParent: $('#addModal'),
  });

  let currentRoom = getCurrentRoom();

  let rooms = [];

  if (!form) {
    return;
  }

  const resetForm = () => {
    dateElement.value = '';
    startTimeElement.value = '';
    endTimeElement.value = '';
    roomElement.value = '';
    commentElement.value = '';
    Array.from(extraUsersElement.selectedOptions).forEach((option) => {
      option.selected = false;
    });
  };

  /**
   * Fetch a list of available rooms for a date + time
   * @param payload
   */
  const getAvailableRooms = async (payload: AvailableRoomPayload): Promise<Room[]> => {
    return await ky
      .post('/api/rooms/availability/', {
        json: payload,
        headers: { 'X-CSRFToken': csrftoken },
      })
      .json();
  };

  /**
   * Create options for each room found
   * @param room
   */
  const createRoomOption = (room) => {
    const element = document.createElement('option');
    element.value = room.id.toString();
    element.innerText = room.name;

    if (currentRoom === room.id) {
      element.selected = true;
    }

    roomElement.append(element);
  };

  /**
   * What happen the reservation form changes
   */
  const handleFormChange = async () => {
    buttonElement.disabled = true;
    const date = dateElement.value;
    const startTime = startTimeElement.value;
    const endTime = endTimeElement.value;
    const comment = commentElement.value;

    // If there's a date, two hours and a comment, fetch availabilities
    if (date && startTime && endTime && comment) {
      const payload = {
        date,
        startTime,
        endTime,
      };

      const newRooms: Room[] = await getAvailableRooms(payload);

      if (newRooms.length > 0) {
        currentRoom = getCurrentRoom();

        // Found rooms, building the select
        // Don't build the select if selected room is not found
        if (newRooms.length !== rooms.length || rooms.length === 0) {
          roomElement.innerHTML = '';
          newRooms.map((room) => createRoomOption(room));
          rooms = newRooms;
        }

        roomElement.disabled = false;
        buttonElement.disabled = false;
        removeErrorMessage();
      } else {
        roomElement.disabled = true;
        displayErrorMessage(
          "Aucune salle disponible pour ce créneau. Mettez à jour la date et/ou l'heure pour réserver",
        );
      }
    }
  };

  /**
   * Remove the success message in the modal
   */
  const removeSuccessMessage = () => {
    newReservationSuccessElement.classList.add('d-none');
    newReservationSuccessElement.innerHTML = '';
  };

  /**
   * Remove the error message in the modal
   */
  const removeErrorMessage = () => {
    newReservationAlertElement.classList.add('d-none');
    newReservationAlertElement.innerHTML = '';
  };

  /**
   * Display an error message in the modal
   * @param message
   */
  const displaySuccessMessage = (message: string) => {
    newReservationSuccessElement.classList.remove('d-none');
    newReservationSuccessElement.innerHTML = message;
    buttonElement.disabled = true;
  };

  /**
   * Display an error message in the modal
   * @param message
   */
  const displayErrorMessage = (message: string) => {
    newReservationAlertElement.classList.remove('d-none');
    newReservationAlertElement.innerHTML = message;
    buttonElement.disabled = true;
  };

  /**
   * What happen the reservation form is submitted
   */
  const handleFormSubmit = async (event) => {
    event.preventDefault();

    // Disable the submit button
    buttonElement.disabled = true;

    const date = dateElement.value;
    const startTime = startTimeElement.value;
    const endTime = endTimeElement.value;
    const comment = commentElement.value;
    const room = roomElement.value;
    const extraUsers = Array.from(extraUsersElement.selectedOptions)
      .filter((option) => option.selected)
      .map((option) => parseInt(option.value, 10));

    const payload = {
      date,
      startTime,
      endTime,
      comment,
      room,
      extraUsers,
    };

    try {
      const data: Reservation = await ky
        .post('/api/reservations/', {
          json: payload,
          headers: { 'X-CSRFToken': csrftoken },
        })
        .json();

      window.calendar.addEvent({
        id: data.id.toString(),
        title: data.title,
        start: `${data.date}T${data.startTime}`,
        end: `${data.date}T${data.endTime}`,
        resourceId: data.room.toString(),
        backgroundColor: data.color,
        borderColor: data.color,
        editable: true,
        extendedProps: {
          room: data.room,
          user: window.userId,
          canModify: data.canModify,
          extraUsers: data.extraUsers,
        },
      });

      displaySuccessMessage('Réservation ajoutée avec succès');
      setTimeout(() => {
        addModalCloseButtonElement.click();
        removeSuccessMessage();
        resetForm();
      }, 5000);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();

        if ('nonFieldErrors' in errorJson) {
          displayErrorMessage(errorJson.nonFieldErrors.join('. '));
        }
      }
    }
  };

  form.addEventListener('change', handleFormChange);
  form.addEventListener('submit', handleFormSubmit);
});
